export default __webpack_public_path__ + "static/media/main.339774bf.svg";